const comments = [
  {
    name: '舞者小K',
    avatar: 'K',
    date: '2026-07-29',
    content: '每天都会来每日大赛入口刷一下街舞大赛的新作品，作品介绍写得很到位，比自己在视频平台大海捞针高效多了。大赛类型分类也很清晰，推荐！',
    likes: 128,
  },
  {
    name: '音乐人阿杰',
    avatar: '杰',
    date: '2026-07-28',
    content: '原创音乐大赛的专题做得非常用心，从赛制解析到选手故事都有深度。每日大赛列表更新也很及时，已经推荐给身边做音乐的朋友了。',
    likes: 96,
  },
  {
    name: '设计狮小李',
    avatar: '李',
    date: '2026-07-27',
    content: 'AI创意设计大赛的解读太精彩了，很多前沿的AI艺术创作案例在这里第一次看到。每日大全汇总得很全面，是我每周必看的栏目。',
    likes: 87,
  },
  {
    name: '短视频博主CC',
    avatar: 'C',
    date: '2026-07-26',
    content: '作为短视频创作者，每日大赛入口的爆款分析对我帮助很大。通过大赛类型的梳理，我能快速了解各赛道的最新趋势，找灵感必备的每日大赛平台。',
    likes: 73,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          读者评论
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口用户真实反馈，看看大家怎么说
        </p>

        <div className="space-y-4">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-700 font-heading">
                    {comment.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-900">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.date}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}